<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar d-none d-md-block">
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_github", "footer", "github")' href="https://github.com/abdisamadovich" target='_blank'>
                    <i class="fab fa-github"></i>
                </a>
            </li>
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_linkedin", "footer", "github")' href="https://www.linkedin.com/in/abdisamadovich" target='_blank'>
                    <i class="fab fa-linkedin-in"></i>
                </a>
            </li>
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_telegram", "footer", "github")' href="https://t.me/dotnetjon" target='_blank'>
                    <i class="fab fa-telegram"></i>
                </a>
            </li>
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_instagram", "footer", "github")' href="https://www.instagram.com/boboquloff_" target='_blank'>
                    <i class="fab fa-instagram"></i>
                </a>
            </li>
        </ul>
        <div class="footer-right-bar d-none d-md-block">
            <a (click)='analyticsService.sendAnalyticEvent("click_send_mail", "footer", "email")' href="mailto:abdisamadovich2000@gmail.com" target='_blank'>abdisamadovich2000&#64;gmail.com </a>
        </div>
    </div>

    <div class="footer-credits text-center" >
        <a (click)='analyticsService.sendAnalyticEvent("click_github_portfolio_andresjose", "footer", "click")' href="https://github.com/abdisamadovich/Islombek-Boboqulov-portfolio" target="_blank" rel="nofollow noopener noreferrer">
            <div>Built with Angular by Islombek Boboqulov</div>
        </a>
        <a (click)='analyticsService.sendAnalyticEvent("click_github_portfolio_brittany", "footer", "click")' href="https://github.com/abdisamadovich" target="_blank" rel="nofollow noopener noreferrer">
            <div class="mt-2">Designed by Islombek Boboqulov</div>
        </a>
    </div>

</footer>